import React, { useEffect, useState } from "react";
import { fetchHomeVideo } from "../../lib/api";

const ytId = (url) => {
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  return m ? m[1] : null;
};

/** Home page video — URL is editable from the Owner Panel (YouTube link or direct mp4). Hidden until a URL is set. */
export const HomeVideo = () => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    fetchHomeVideo()
      .then((data) => setUrl((data?.url || "").trim()))
      .catch(() => setUrl(""));
  }, []);

  if (!url) return null;

  const yt = ytId(url);

  return (
    <section className="py-12 sm:py-16 bg-charcoal relative overflow-hidden" data-testid="home-video-section">
      <span aria-hidden="true" className="pointer-events-none select-none absolute -top-4 right-0 font-heading italic text-[18vw] leading-none text-ivory/[0.04] whitespace-nowrap">
        In Motion
      </span>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 relative">
        <div className="text-center">
          <p className="uppercase tracking-[0.25em] text-xs font-semibold text-gold">From our looms</p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-ivory mt-3">
            Watch the Weave <span className="italic font-light text-gold">Come Alive</span>
          </h2>
        </div>
        <div className="mt-7 ring-1 ring-gold/30 shadow-2xl shadow-black/40">
          {yt ? (
            <iframe
              src={`https://www.youtube.com/embed/${yt}?rel=0`}
              title="R V Ilkal Sarees video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full aspect-video block"
              data-testid="home-video-embed"
            />
          ) : (
            <video
              src={url}
              autoPlay
              muted
              loop
              playsInline
              controls
              className="w-full aspect-video object-cover block bg-black"
              data-testid="home-video-player"
            />
          )}
        </div>
      </div>
    </section>
  );
};
